module.exports = __webpack_public_path__ + "log-in/img/ca.ad152714.svg";